/* eslint-disable */
/**
 * WARNING: THIS FILE IS AUTO-GENERATED, DO NOT EDIT IT DIRECTLY!
 */

import * as Types from './types'

import { GraphQLClient } from 'graphql-request';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import fetcher from '../../fetchers/fetcher';

export type ResendSignupEmailMutationVariables = Types.Exact<{
  email: Types.Scalars['String'];
}>;


export type ResendSignupEmailMutation = { __typename?: 'Mutation', resendSignupEmail?: boolean | null };


export const ResendSignupEmailDocument = /*#__PURE__*/ `
    mutation ResendSignupEmail($email: String!) {
  resendSignupEmail(email: $email)
}
    `;
export const useResendSignupEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ResendSignupEmailMutation, TError, ResendSignupEmailMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ResendSignupEmailMutation, TError, ResendSignupEmailMutationVariables, TContext>(
      ['ResendSignupEmail'],
      (variables?: ResendSignupEmailMutationVariables) => fetcher<ResendSignupEmailMutation, ResendSignupEmailMutationVariables>(client, ResendSignupEmailDocument, variables, headers)(),
      options
    );